export default __webpack_public_path__ + "static/media/0044.7ef04386.jpg";